module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('el-date-picker', {
    staticClass: "report-date-picker",
    attrs: {
      "editable": false,
      "type": "daterange",
      "placeholder": "Выберите период"
    },
    model: {
      value: (_vm.dates),
      callback: function($$v) {
        _vm.dates = $$v
      },
      expression: "dates"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.loadNewsReport(_vm.dates)
      }
    }
  }, [_vm._v("Скачать отчет")])], 1), _vm._v(" "), _c('router-link', {
    staticClass: "button is-fullwidth",
    attrs: {
      "to": {
        name: 'NotificationEditor',
        params: {
          id: 'new'
        }
      }
    }
  }, [_vm._v("Добавить новость")]), _vm._v(" "), _c('ul', {
    staticClass: "list column is-8 is-offset-2"
  }, _vm._l((_vm.news), function(article) {
    return _c('router-link', {
      key: article.id,
      staticClass: "box",
      attrs: {
        "to": {
          name: 'NotificationEditor',
          params: {
            id: article.id
          }
        },
        "tag": "li"
      }
    }, [_c('strong', [_vm._v(_vm._s(article.title))]), _vm._v(" - "), _c('strong', [_vm._v(_vm._s(_vm._f("formatDate")(article.publishDate)))]), _vm._v(" "), _c('button', {
      staticClass: "delete is-pulled-right",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.del(article.id)
        }
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("truncate")(_vm._f("stripHTML")(article.text.replace(/(<([^>]+)>)/ig, "")), 140)))])])
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cd56c0e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notifications/Index.vue
// module id = 972
// module chunks = 0